import template from './inquiry-modal-preview.pug';

export const InquiryModalPreviewModalComponent = {
  template,
  bindings:{
    resolve: '<',
    modalInstance: '<',
  },
  controller: class InquiryModalPreviewModalComponent {
    constructor(Inquiry, AlertBox, CustomField, $async, $log) {
      'ngInject';

      this.Inquiry = Inquiry;
      this.$log = $log;
      this.AlertBox = AlertBox;
      this.CustomField = CustomField;
      this.update = $async(this.update.bind(this));
      this.loadCustomFields = $async(this.loadCustomFields.bind(this));

      this.formState = 'show';
    }

    $onInit() {
      this.record = this.resolve.record;
      this.loadCustomFields();
    }

    close() {
      this.modalInstance.close(void(0));
    }

    navigateToRecord() {
      if (this.record.id) {
        this.Inquiry.navigateToShow(this.record.id);
        this.close();
      }
    }

    changeFormState(state) {
      if (state == 'edit') {
        this.record = angular.copy(this.record);
      }
      this.formState = state;
    }

    async loadCustomFields() {
      try {
        this.cfGroups = await this.CustomField.loadGroups({ module: 'inquiries' });
      } catch (e) {
        this.$log.error(e);
      }
    }

    async update({ inquiry }) {
      try {
        const resp = await this.Inquiry.update(inquiry.id, this.Inquiry.updateAttributes(inquiry));

        if (resp && resp.id) {
          this.record = resp;
          this.AlertBox.addMessage('alert.updated', { type: 'success' });
          // this.changeFormState('show');
        }
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
